
$(document).ready(function () {
    var defaultPaymentAmount = 0;

    // Enabled  payment button by default if accept terms is clicked
    document.getElementById("pay").disabled = !$("#acceptTerms").prop('checked');

    // Set payment option selected if ID is set
    if (document.getElementById("paymentId").value.length > 0) {
        var paymentId = document.getElementById("paymentId").value;
        var selectedPaymentLi = $("#paymentOptions").find("[data-id='" + paymentId + "']");

        $("#paymentName").text(selectedPaymentLi.text());
    }

    // Set payment amount extra if selected
    if (document.getElementById("paymentAmountExtra").value.length > 0) {
        document.getElementById("extraPaymentTerms").checked = true;
        document.getElementById("paymentAmountExtra").disabled = false;

        $("#PaymentAmountExtraAnonymous").toggle();
        $("#PaymentAmountExtraAnonymousLabel").toggle();
    }

    $("#acceptTerms").on("click", function () {
        document.getElementById("pay").disabled = !this.checked;
    });

    $("#extraPaymentTerms").on("click", function () {
        document.getElementById("paymentAmountExtra").disabled = !this.checked;

        if (this.checked) {
            document.getElementById("paymentAmountExtra").value = defaultPaymentAmount;

            document.getElementById("paymentAmountExtra").focus();
            document.getElementById("paymentAmountExtra").select();
        }

        $("#PaymentAmountExtraAnonymous").toggle();
        $("#PaymentAmountExtraAnonymousLabel").toggle();
    });

    $("#paymentOptions li").click(function () {
        // Set selected text
        $("#paymentName").text($(this).text());

        // Set selected ID
        document.getElementById("paymentId").value = $(this).data("id");
    });

    $("#countryList li").click(function () {
        document.getElementById("countryName").innerHTML = $(this).data("name");
        document.getElementById("countryId").value = $(this).data("id");
    });
});


